import React from 'react';
import { Quote } from 'lucide-react';

const TESTIMONIALS = [
  {
    quote:
      'Most platforms sell you automation and hide the risk layer. Talas puts the risk layer in front of the order router. That\u2019s the difference.',
    name: 'M. Reyes',
    role: 'Independent Futures Trader',
  },
  {
    quote:
      'Paper-mode validation saved me from shipping a broken config twice in the first month. I\u2019d rather have the guardrails than the freedom to lose money faster.',
    name: 'J. Holcomb',
    role: 'Algo Strategy Builder',
  },
  {
    quote:
      'I run three accounts. Per-account risk profiles, isolated session keys, and audit logs I can actually read. This is the first platform that felt operator-grade.',
    name: 'D. Crane',
    role: 'Multi-Account Operator',
  },
];

export default function Testimonials() {
  return (
    <section className="relative border-t border-white/5">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-5 sm:px-6 lg:px-12 py-12 lg:py-16 lg:py-24">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-[10px] tracking-[0.25em] font-mono gold-text">SUBSCRIBER NOTES</p>
          <h2 className="font-display mt-5 text-3xl sm:text-4xl md:text-5xl font-bold leading-[1.05] text-white">
            What operators
            <br />
            <span className="gold-text">are saying.</span>
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t) => (
            <div
              key={t.name}
              className="relative border border-white/[0.08] rounded-md p-8 bg-[#0c0c0e] hover:border-[#d8b34a]/30 transition-colors"
            >
              <Quote size={20} className="gold-text opacity-60" strokeWidth={1.4} />
              <p className="mt-5 text-sm text-zinc-200 leading-relaxed">
                “{t.quote}”
              </p>
              <div className="mt-7 pt-5 border-t border-white/5">
                <p className="text-sm font-semibold text-white">{t.name}</p>
                <p className="text-xs text-zinc-500 mt-1 font-mono tracking-wider">{t.role}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-xs text-zinc-500 max-w-2xl mx-auto">
          Subscriber commentary. Individual results not representative of typical outcomes. Trading involves substantial risk.
        </p>
      </div>
    </section>
  );
}
